import React, { useState } from 'react';
import OtpInput from 'react18-input-otp';
import './VerificationCodeForm.scss';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';
import { LinkComponent } from '../../LinkComponent';
import clsx from 'clsx';
import { Label } from '../../developers/page-components/Label';

interface Props {
	number?: string;
	onBackClick?: () => void;
	onContinue: (code: string, session?: string, email?: string, rememberMFA?: boolean) => void;
	isLoading?: boolean;
	session?: string;
	email?: string;
	showCheckbox?: boolean;
}

export const VerificationCodeForm = (props: Props): React.ReactElement => {
	const { number, onBackClick, onContinue, isLoading, session, email, showCheckbox } = props;
	const [result, setResult] = useState<string>();
	const [rememberMFA, setRememberMFA] = useState<boolean>(false);

	const handleChange = (res: string): void => {
		setResult(res);
	};

	const handleContinue = (e): void => {
		e.preventDefault();
		onContinue(result, session, email, rememberMFA);
	};

	return (
		<form onSubmit={handleContinue}>
			{
				number
					? (
						<>
							<div className="text-center fs-7">
								Enter the 6-digit code we sent to{' '}
								<span className="fw-bolder">{number}</span>
							</div>
							<div className="text-center fs-7 mb-10">
								Didn`t received a code?{' '}
								<span className="cursor-pointer text-danger">Resend.</span>
							</div>
						</>
					) : (
						<div className="text-center fs-7 px-13">
							To continue, please enter the 6-digit verification code generated by your{' '}
							<span className="fw-bolder">authenticator app</span>{' '}
							(
							<LinkComponent text="Android" link='https://play.google.com/store/search?q=google+authenticator+code&c=apps&hl=en&gl=US'/>,{' '}
							<LinkComponent text="iOS" link='https://apps.apple.com/us/app/google-authenticator/id388497605'/>).
						</div>
					)
			}
			<div className='d-flex justify-content-center mt-10'>
				{/*@ts-ignore*/}
				<OtpInput
					value={result}
					onChange={handleChange}
					numInputs={6}
					inputStyle="verification-input rounded"
				/>
			</div>
			{
				showCheckbox && (
					<div className="d-flex align-items-center form-check mt-10 ps-20 ms-20">
						<input
							type="checkbox"
							className={clsx('form-check-input cursor-pointer checkbox-size')}
							disabled={isLoading}
							checked={rememberMFA}
							onChange={(): void => setRememberMFA(prev => !prev)}
						/>
						<Label fieldLabel="Remember device for 30 days" additionalClass="form-check-label ms-5 fs-6"/>
					</div>
				)
			}
			<div className="text-center mt-10">
				{
					onBackClick && (
						<ButtonComponent
							buttonName="Back"
							buttonType={BUTTON_TYPE.CANCELLED}
							additionalClass="btn-sm  me-10"
							onButtonClick={onBackClick}
						/>
					)
				}
				<ButtonComponent
					buttonName={onBackClick ? 'Continue' : 'Confirm'}
					additionalClass="btn-sm w-110px"
					type="submit"
					loading={isLoading}
				/>
			</div>
		</form>
	);
};
